//============================================================================
// Name        : item_group.ts
// Purpose     : Implement item group logic
// Created     : 2021-02-22
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

declare var client_store_merge_item_group_modal_path: string;
declare var client_store_split_item_group_modal_path: string;
declare var client_store_change_status_item_group_modal_path: string;

class InitButtons {
    constructor() {
        $(document).on("change", () => {
            const checked = $("[id^=epc_tags_]:checked").length;
            const changeStatusForbidden = $("#btn-change-status").hasClass("change-status-permission-denied");

            if (checked > 1) {
                $("#btn-merge").removeClass("disabled");
                $("#btn-split").addClass("disabled");
                if (!changeStatusForbidden) {
                    $("#btn-change-status").removeClass("disabled");
                } else {
                    $("#btn-change-status").addClass("disabled");
                }
            } else if (checked === 1) {
                $("#btn-merge").addClass("disabled");
                $("#btn-split").removeClass("disabled");
                if (!changeStatusForbidden) {
                    $("#btn-change-status").removeClass("disabled");
                } else {
                    $("#btn-change-status").addClass("disabled");
                }
            } else {
                $("#btn-merge").addClass("disabled");
                $("#btn-split").addClass("disabled");
                $("#btn-change-status").addClass("disabled");
            }
        });

        $("#btn-merge").on("click", (e) => {
            e.preventDefault();
            const array = [];
            $("[id^=epc_tags_]:checked").each(function() {
                array.push($(this).val());
            });
            if (array.length < 2) return;

            $.ajax({
                type: "GET",
                url: client_store_merge_item_group_modal_path,
                data: {
                    epc_tag_ids: array
                }
            });
        });

        $("#btn-split").on("click", (e) => {
            e.preventDefault();
            if ($("[id^=epc_tags_]:checked").length !== 1) return;
            $.ajax({
                type: "GET",
                url: client_store_split_item_group_modal_path,
                data: {epc_tag_id: $("[id^=epc_tags_]:checked").val()}
            });
        });

        $("#btn-change-status").on("click", (e) => {
            e.preventDefault();
            if ($("#btn-change-status").hasClass("change-status-permission-denied") || $("#btn-change-status").hasClass("disabled")) {
                return;
            }
            const array = [];
            $("[id^=epc_tags_]:checked").each(function() {
                array.push($(this).val());
            });
            if (array.length < 1) return;

            $.ajax({
                type: "GET",
                url: client_store_change_status_item_group_modal_path,
                data: {
                    epc_tag_ids: array,
                }
            });
        });

    }
}

export function LoadPage() {
    InitPage("items item_group", () => {
        const init_btns = new InitButtons();
    });
}
